import React from "react";
import { DragDropContext, Draggable, DropResult, Droppable } from "react-beautiful-dnd";

interface ISortList {
    items: Array<any>,
    renderItem: (item: any, i: number) => JSX.Element,
    onSort: (list: any) => void,
}

export const SortableList: React.FunctionComponent<ISortList> = (props) => {
    const { items, renderItem, onSort } = props;

    async function handleDND(result: DropResult) {
        const { source, destination } = result;
        if (!destination) return;
        if (destination.droppableId === source.droppableId && destination.index === source.index) return;

        let list = items;
        const sValue = items[destination?.index];
        const dValue = items[source?.index];

        list[destination?.index] = dValue;
        list[source?.index] = sValue;

        onSort(list);
    };

    return (
        <DragDropContext onDragEnd={(r, p) => handleDND(r)}>
            <Droppable droppableId="main-container" direction="vertical" type="row">
                {(provided) => {
                    return (
                        <div className="main-container" {...provided.droppableProps} ref={provided.innerRef}>
                            {items?.map((s, i) => {
                                return (
                                    <Draggable draggableId={`row${i}`} key={`row${i}`} index={i}>
                                        {(provided) => {
                                            return (
                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                    {
                                                        renderItem(s, i)
                                                    }
                                                </div>
                                            )
                                        }}
                                    </Draggable>
                                )
                            })}
                            {provided.placeholder}
                        </div>
                    )
                }}
            </Droppable>
        </DragDropContext>
    )
};

